import * as React from 'react';
import { IComponent, ComponentHelper, EComponentTypes, IJESettingsSidebar } from '../../helpers';
import { Properties } from '../';
import {
    Panel, PanelType,
    Button, ButtonType, TextField, Toggle, DialogFooter, MessageBar, MessageBarType, Link
} from 'office-ui-fabric-react';

interface IProps {
    component?: IComponent;
    isOpen?: boolean;
    pinned?: boolean;
    updateJourneyEngineSettingsList?: (key: string, value: any) => void;
    close?: (save?: boolean, isCreate?: boolean) => void;
    toggle?: () => void;
    togglePin?: () => void;
    deleteJESetting: () => void;
    propertiesToExclude?: string[];
    sidebar: IJESettingsSidebar;
};

export class JESettingsSidebar extends React.Component<IProps, any> {

    constructor(props: any) {
        super(props);
    }

    private inputTimeout;

    private debounceValue = (key: string, value: any) => {

        if (this.inputTimeout) {
            clearTimeout(this.inputTimeout);
        }
        const currentValue = value; // Store the current value

        this.inputTimeout = setTimeout(() => {
            this.props.sidebar.type === 'edit' ?
                this.props.updateJourneyEngineSettingsList(key, value)
                :
                this.props.updateJourneyEngineSettingsList(key, value)
                ;
        }, 200);
    }
    public render() {

        let {
            component, isOpen, pinned, updateJourneyEngineSettingsList, toggle, togglePin, propertiesToExclude
        } = this.props;

        if (!isOpen)
            return (null);

        let title: string;
        if (this.props.sidebar && this.props.sidebar.type) {
            title = this.props.sidebar.type === 'new' ? 'Create JE Setting' : 'JE Setting';
        }

        let jesetting = this.props.sidebar && this.props.sidebar.jesetting;

        return <Panel
            className={"sidebar " + (pinned ? 'pinned' : '')}
            isOpen={isOpen}
            onDismiss={() => toggle()}
            type={PanelType.medium}
            headerText={title}
            headerClassName={'jesettings'}
            isLightDismiss={true}>
            {this.props.sidebar ?
                <div>
                    {this.props.sidebar && this.props.sidebar.isSuccess ?
                        <MessageBar actions={<div></div>}
                            messageBarType={MessageBarType.success}
                            isMultiline={false}>
                            Changes saved.
                        </MessageBar>
                        :
                        null
                    }
                    {this.props.sidebar && this.props.sidebar.error ?
                        <MessageBar actions={<div></div>}
                            messageBarType={MessageBarType.error}
                            isMultiline={false}>
                            {this.props.sidebar.error}
                        </MessageBar>
                        :
                        null
                    }
                    {this.props.sidebar && this.props.sidebar.formValidationError && this.props.sidebar.formValidationError.length ?
                        <MessageBar actions={<div></div>}
                            messageBarType={MessageBarType.error}
                            isMultiline={false}>
                            Please fill up all the required fields.
                        </MessageBar>
                        :
                        null
                    }
                    {
                        this.props.sidebar.type === 'edit' ?
                            <TextField disabled={true} label={'Journey Engine Setting'} value={(jesetting && jesetting.journeyEngineSettingsId) || ''}
                                onBlur={(val) => null} required={true} />
                            : null
                    }
                    <TextField label={'Name'} value={(jesetting && jesetting.nameField) || ''}
                        onChanged={(val) => {
                            this.debounceValue('nameField', val);
                        }} required={true} />
                    <TextField label={'Key'} value={(jesetting && jesetting.keyField) || ''}
                        onChanged={(val) => {
                            this.debounceValue('keyField', val);
                        }} required={true} />
                    <TextField multiline={true} resizable={true} label={'Value'} value={(jesetting && jesetting.valueField) || ''}
                        onChanged={(val) => {
                            this.debounceValue('valueField', val);
                        }} />
                    <TextField multiline={true} resizable={true} label={'Description'} value={(jesetting && jesetting.description) || ''}
                        onChanged={(val) => {
                            this.debounceValue('description', val);
                        }} />
                    {
                        this.props.sidebar.type === 'edit' ?
                            <Toggle checked={jesetting && jesetting.serverOnly === 0 ? false : true} label={'Server Only'} onText="Yes" offText="No"
                                onChanged={(val) => {
                                    this.debounceValue('serverOnly', val ? 1 : 0);
                                }} />
                            : null
                    }

                </div>
                :
                null}
            {/* <Properties componentId={component.Id} properties={ComponentHelper.getProperties(component, true)} primaryOnly={false} change={updateProperty}
                propertiesToExclude={propertiesToExclude}
            /> */}

            <DialogFooter>
                <Button tabIndex={1001}
                    buttonType={ButtonType.normal} onClick={() => this.props.close(false)}>Cancel</Button>
                {this.props.sidebar.type === 'edit' ?
                    <Button tabIndex={1002} onBlur={() => { null; }}
                        buttonType={ButtonType.normal} onClick={() => this.props.deleteJESetting()} >Delete</Button>
                    :
                    null
                }
                {this.props.sidebar.type === 'edit' ?
                    <Button tabIndex={1002} onBlur={() => { null; }}
                        buttonType={ButtonType.primary} onClick={() => this.props.close(true)} >Save</Button>
                    :
                    <Button tabIndex={1002} onBlur={() => { null; }}
                        buttonType={ButtonType.primary} onClick={() => this.props.close(true, true)} >Create</Button>
                }
            </DialogFooter>


        </Panel >;

    };

};


// WEBPACK FOOTER //
// ./source/ts/components/layout/jesettings-sidebar.tsx